const defaultResponsiveStyle = {
  '& .RaDataTable-tableWrapper': {
    overflowX: 'auto',
  },
};

export const boldDataTableStyle = {
  ...defaultResponsiveStyle,
  '& .RaDataTable-headerCell': {
    fontWeight: 'bold',
    backgroundColor: 'transparent',
  },
};

export const noRowBorderDataTableStyle = {
  ...defaultResponsiveStyle,
  '& .RaDataTable-thead': { borderBottom: 'solid', borderBottomColor: '#0000001f', borderBottomWidth: '2px' },
  '& .RaDataTable-rowCell': {
    border: 'none',
  },
  '& .RaDataTable-headerCell': {
    fontWeight: 'bold',
  },
};

export const listViewDataTableStyle = {
  ...defaultResponsiveStyle,
  '& .RaDataTable-thead': { borderBottom: 'solid', borderBottomColor: '#0000001f', borderBottomWidth: '2px' },
  '& .RaDataTable-headerCell': {
    fontWeight: 'bold',
  },
  '& .RaDataTable-row': {
    '&:last-child td': {
      borderBottom: 'none',
    },
  },
};

export const ruleListDefaultStyle = {
  ...defaultResponsiveStyle,
  '& .RaDataTable-thead': { borderBottom: 'solid', borderBottomColor: '#0000001f', borderBottomWidth: '2px' },
  '& .RaDataTable-headerCell': {
    fontWeight: 'bold',
    paddingLeft: '0px',
  },
  '& .RaDataTable-table': {
    'table-layout': 'fixed',
  },
  '& .RaDataTable-tbody': {
    '& .MuiTableCell-sizeSmall': {
      padding: '0px 0px 0px 0px',
    },
  },

};

export const expandableDataTableStyles = {
  ...defaultResponsiveStyle,
  '& .RaDataTable-thead': { borderBottom: 'solid', borderBottomColor: '#0000001f', borderBottomWidth: '2px' },
  '& .RaDataTable-headerCell': {
    fontWeight: 'bold',
  },
  '& .RaDataTable-table': {
    'table-layout': 'fixed',
  },
  '& .RaDataTable-tbody': {
    '& .MuiTableCell-sizeSmall': {
      padding: '0px 0px 0px 0px',
    },
  },
};

export const expandedDataTableStyles = {
  ...defaultResponsiveStyle,
  '& .RaDataTable-thead': {
    display: 'none',
  },
  '& .RaDataTable-table': {
    'table-layout': 'fixed',
  },
  '& .RaDataTable-tbody': {
    '& .MuiTableCell-sizeSmall': {
      paddingLeft: '1%',
      backgroundColor: '#F5F5F5',
    },
  },
  '& .RaDataTable-row': {
    '&:last-child td': {
      borderBottom: 'none',
    },
  },

};
